export default "__VITE_ASSET__QCGEe_x6__"